/**
 * Main App Component
 * Root component for Volca Drum Editor
 */

import { AppContent } from './AppContent';
import { PARAMETER_DISPLAY_TRANSFORMS, MIDIProvider, PartProvider } from '@midi-volca-drum/midi';
import { SettingsProvider } from './contexts/SettingsContext';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';

export const App = () => {
  // MIDI configuration
  const midiConfig = {
    autoHideParameterDisplay: true,
    parameterDisplayTransforms: PARAMETER_DISPLAY_TRANSFORMS,
  };

  return (
    <ErrorBoundary>
      <SettingsProvider>
        <MIDIProvider config={midiConfig}>
          <PartProvider>
            <AppContent />
          </PartProvider>
        </MIDIProvider>
      </SettingsProvider>
    </ErrorBoundary>
  );
};
